import React, { useEffect, useState } from "react";
import $ from "jquery";
import KhuyenCaoPhanBonApi from "../../api/KhuyenCaoPhanBonApi";
import Draggable from "react-draggable";
import NumberFormat from "react-number-format";
import { Loading } from "../../shared/loading/Loading";
import Select from "react-select";

export const KhuyenCaoPhanBon = (props) => {
  const [hienTrang, setHienTrang] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectCayTrong, setSelectCayTrong] = useState();
  var [phanBon, setPhanBon] = useState({ n: 0, p: 0, k: 0 });
  var [coSo, setCoSo] = useState({ n: 0, p: 0, k: 0 });

  const handleClose = () => {
    $("#modalgopy").modal("hide");
    $("#modalgopy").modal("dispose");
    props.handleClose();
  };

  useEffect(() => {
    if (props.show) {
      loadThongTin();
      $("#modalgopy").modal("show");
    }
  }, [props.show]);

  const loadThongTin = async () => {
    setLoading(true);
    const result = await KhuyenCaoPhanBonApi.getDetail(props.x, props.y);
    setHienTrang(result);
    setLoading(false);
  };

  const tinhCanSo = (nMax, nMin, pMax, pMin, kMax, kMin) => {
    if (coSo.n > nMax) {
      phanBon.n = nMax;
    } else if (coSo.n < nMin) {
      phanBon.n = nMin;
    } else {
      phanBon.n = coSo.n;
    }
    if (coSo.p > pMax) {
      phanBon.p = pMax;
    } else if (phanBon.p < pMin) {
      phanBon.p = pMin;
    } else {
      phanBon.p = coSo.p;
    }
    if (coSo.k > kMax) {
      phanBon.k = kMax;
    } else if (coSo.k < kMin) {
      phanBon.k = kMax;
    } else {
      phanBon.k = coSo.k;
    }
    setPhanBon({ ...phanBon });
  };

  const onChangeCaytrong = (e) => {
    console.log(hienTrang)
    switch (e.value) {
      case "LUAXUAN":
      
        coSo.n =
          141.7 -
          1.33 * ((0.2 * 1.05 * 10000 * (hienTrang.oc * 1.724 * 10)) / 1000) +
          0.25 * 260;
        coSo.p = 100- hienTrang.p2o5;
        //coSo.k = 152.85 - 145.37 * (hienTrang.k2o / 39.1);
        coSo.k = 0.03*(hienTrang.cecdat - (hienTrang.k2o/39.1))*331
        setCoSo({ ...coSo });
        tinhCanSo(120, 100, 90, 30, 100, 60);
        break;
      case "LUAMUA":
        coSo.n =
          (141.7 -
            1.33 * ((0.2 * 1.05 * 10000 * (hienTrang.oc * 1.724 * 10)) / 1000) +
            0.25 * 260) *
          0.85;
        // coSo.p = (205.87 - 0.54 * (hienTrang.p2o5 * 10)) * 0.85;
        // coSo.k = (152.85 - 145.37 * (hienTrang.k2o / 39.1)) * 0.85;
        coSo.p = (100- hienTrang.p2o5)*0.85;
        //coSo.k = 152.85 - 145.37 * (hienTrang.k2o / 39.1);
        coSo.k = (0.03*(hienTrang.cecdat - (hienTrang.k2o/39.1))*331)*0.85;
        setCoSo({ ...coSo });
        tinhCanSo(
          120 * 0.85,
          100 * 0.85,
          90 * 0.85,
          30 * 0.85,
          100 * 0.85,
          60 * 0.85
        );
        break;
      case "NGO":
        //coSo.n = 108.56 - 2.6 * (hienTrang.oc * 1.724 * 10);
        coSo.n = 209.51 - 2.17 * (hienTrang.oc * 1.724 * 10);
        coSo.p = 1093.75 - 437.15 * Math.log(hienTrang.p2o5 * 10);
        coSo.k = 270.89 - 404.38 * (hienTrang.k2o / 39.1);
        setCoSo({ ...coSo });
        tinhCanSo(500, 20, 90, 50, 120, 60);
        break;
      case "LAC":   
        //coSo.n = 209.51 - 2.17 * (hienTrang.oc * 1.724 * 10);
        coSo.n = 108.56 - 2.6 * (hienTrang.oc * 1.724 * 10);
        coSo.p = 205.87 - 0.54 * (hienTrang.p2o5 * 10);
        coSo.k = 152.85 - 145.37 * (hienTrang.k2o / 39.1);
        setCoSo({ ...coSo });
        tinhCanSo(40, 20, 90, 60, 90, 45);
        break;
      case "KHOAI":
        coSo.n = hienTrang.oc * 1.724 * 10;
        //coSo.p = 205.87 - 0.54 * (hienTrang.p2o5 * 10);
        coSo.p = 126.31-0.27 * (hienTrang.p2o5 * 10);

        //coSo.k = 152.85 - 145.37 * (hienTrang.k2o / 39.1);
        coSo.k = 134.59-118.99 * (hienTrang.k2o / 39.1);
        setCoSo({ ...coSo });
        phanBon.n = coSo.n > 32 ? 44 : coSo.n < 28 ? 66 : 55;
        phanBon.p = coSo.p < 30 ? 30 : coSo.p > 90 ? 90 : coSo.p;
        phanBon.k = coSo.k < 60 ? 60 : coSo.k > 90 ? 90 : coSo.k;
        setPhanBon({ ...phanBon });
        break;
      
      case "HOA":
        coSo.n = 300;
        coSo.p = 200;
        coSo.k = 150;
        setCoSo({ ...coSo });
        phanBon.n = coSo.n;
        phanBon.p = coSo.p;
        phanBon.k = coSo.k;
        setPhanBon({ ...phanBon });
        break;
      case "CAM":
        coSo.n = hienTrang.oc * 1.724 * 10;
        coSo.p = hienTrang.p2o5 * 10;
        coSo.k = hienTrang.k2o / 39.1;
        setCoSo({ ...coSo });
        phanBon.n = coSo.n > 30 ? 80 : (coSo.n < 26 ? 220: 200);
        phanBon.p = coSo.p < 200 ? 165*0.6 : ((coSo.p > 201 && coSo.p < 400) ? 150*0.6 : ((coSo.p > 401 && coSo.p < 600) ? 127*0.6 : 108*0.6 ));
        phanBon.k = coSo.k < 0.5 ? 213 : ((coSo.k > 0.51  && coSo.k < 0.8) ? 185 : ((coSo.k > 0.81 && coSo.k < 1.5) ? 148 : 118 ));;
        phanBon.k = phanBon.k < 150 ? 150 : (phanBon.k > 220 ? 220: phanBon.k)
        setPhanBon({ ...phanBon });
        break;
      case "NHAN":
        phanBon.n = hienTrang.n > 0.2 ? 150 : (hienTrang.n < 0.12 ? 250 : 200);
        phanBon.p = hienTrang.p2o5 > 15 ? 80 : (hienTrang.p2o5 < 10 ? 100 : 200);
        phanBon.k = hienTrang.k2o > 20 ? 250 : (hienTrang.k2o < 10 ? 350 : 300);
        setPhanBon({ ...phanBon });
        break;
      case "CHUOI":
        phanBon.n = hienTrang.n > 0.2 ? 180 : (hienTrang.n < 0.12 ? 300 : 240);
        phanBon.p = 128;
        phanBon.k = hienTrang.k2o > 30 ? 250 : (hienTrang.k2o < 10 ? 450 : 350);
        setPhanBon({ ...phanBon });
        break;
      case "BUOI":
      coSo.n = hienTrang.oc * 1.724 * 10;
      coSo.p = hienTrang.p2o5 * 10;
      coSo.k = hienTrang.k2o / 39.1;
      setCoSo({ ...coSo });
      phanBon.n = coSo.n > 30 ? 80 : (coSo.n < 26 ? 220: 200);
      phanBon.p = coSo.p < 200 ? 165 : ((coSo.p > 201 && coSo.p < 400) ? 150 : ((coSo.p > 401 && coSo.p < 600) ? 127 : 108 ));
      phanBon.k = coSo.k < 0.5 ? 213 : ((coSo.k > 0.51  && coSo.k < 0.8) ? 185 : ((coSo.k > 0.81 && coSo.k < 1.5) ? 148 : 118 ));;
      //phanBon.k = phanBon.k < 150 ? 150 : (phanBon.k > 220 ? 220: phanBon.k)
      setPhanBon({ ...phanBon });
      break;
      case "MIT":
        phanBon.n = 200;
        phanBon.p = 100;
        phanBon.k = 130;
        setPhanBon({ ...phanBon });
        break;
      case "XOAI":
        phanBon.n = 200;
        phanBon.p = 100;
        phanBon.k = 150;
      setPhanBon({ ...phanBon });
      break;
      case "DIEU":
        phanBon.n = 80;
        phanBon.p = 40;
        phanBon.k = 44;
      setPhanBon({ ...phanBon });
      break;
      case "CAOSU":
        phanBon.n = hienTrang.n > 0.11 ? 200 : 220;
        phanBon.p = phanBon.n - 30;
        phanBon.k = (hienTrang.k2o / 39.1) > 0.5 ? 140 : 210;
        setPhanBon({ ...phanBon });
        break;
      case "HOTIEU":
        phanBon.n = hienTrang.oc > 0.17 ? 290 : 360;
        phanBon.p = hienTrang.p2o5 > 15 ? 120 : 150;
        phanBon.k = hienTrang.k2o > 20 ? 290 : 360;
        setPhanBon({ ...phanBon });
        break;
      case "CAFFE":
        phanBon.n = hienTrang.oc > 1.59 ? 250 : 320;
        phanBon.p = hienTrang.p2o5 > 3.34 ? 80 : 100;
        phanBon.k = hienTrang.k2o > 9.49 ? 250 : 300;
        setPhanBon({ ...phanBon });
        break;
      default:
        coSo.n = 0;
        coSo.p = 0;
        coSo.k = 0;
        setCoSo({ ...coSo });
        tinhCanSo(0, 0, 0, 0, 0, 0);
        break;
    }
  };

  return (
    <Draggable handle=".modal-header">
      <div
        className="modal modal-custom"
        id="modalgopy"
        tabIndex={-1}
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Khuyến cáo phân bón</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form className="user">
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Tỉnh
                  </label>
                  <div className="col-sm-4">
                    <input
                      name="tentinh"
                      type="text"
                      className="form-control"
                      placeholder="Tỉnh"
                      value="Gia Lai"
                      readOnly
                    />
                  </div>
                  <label className="col-sm-2 col-form-label text-right">
                    Huyện
                  </label>
                  <div className="col-sm-4">
                    <input
                      name="tenhuyen"
                      type="text"
                      className="form-control"
                      placeholder="Huyện"
                      value="Chư Pưh"
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Xã
                  </label>
                  <div className="col-sm-4">
                    <input
                      name="tenxa"
                      type="text"
                      className="form-control"
                      placeholder="Xã"
                      value={hienTrang?.tenxa}
                      readOnly
                    />
                  </div>
                  <label className="col-sm-2 col-form-label text-right">
                    Diện tích(ha)
                  </label>
                  <div className="col-sm-4">
                    <NumberFormat
                      className="form-control"
                      value={hienTrang?.dt_ha}
                      thousandSeparator={true}
                      decimalScale={2}
                      readOnly
                    ></NumberFormat>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Hiện trạng
                  </label>
                  <div className="col-sm-10">
                    <input
                      name="tenxa"
                      type="text"
                      className="form-control"
                      placeholder="Hiện trạng"
                      value={hienTrang?.tenht}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Tên đất
                  </label>
                  <div className="col-sm-10">
                    <input
                      name="tenxa"
                      type="text"
                      className="form-control"
                      placeholder="Tên đất"
                      value={hienTrang?.tendat}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Thành phần cơ giới
                  </label>
                  <div className="col-sm-4">
                    <input
                      name="tenhuyen"
                      type="text"
                      className="form-control"
                      placeholder="Thành phần cơ giới đất"
                      value={hienTrang?.tpcg}
                      readOnly
                    />
                  </div>
                  <label className="col-sm-2 col-form-label text-right">
                    Độ phì nhiêu đất
                  </label>
                  <div className="col-sm-4">
                    <input
                      name="tenhuyen"
                      type="text"
                      className="form-control"
                      placeholder="Độ phì nhiêu của đất"
                      value={hienTrang?.dophi}
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label text-right">
                    Cây trồng
                  </label>
                  <div className="col-sm-4">
                    <Select
                      className="select"
                      name="loaicay"
                      placeholder="Chọn cây trồng"
                      value={selectCayTrong}
                      options={hienTrang.CayTrongs}
                      onChange={(e) => onChangeCaytrong(e)}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        height: 30,
                        spacing: {
                          controlHeight: 30,
                          menuGutter: 1,
                          baseUnit: 2,
                        },
                      })}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-12">
                    <h5 className="pb-tieu-de text-center">
                      Lượng phân bón N, P, K cần sử dụng trong vụ (kg/ha/vụ)
                    </h5>
                  </div>
                  <div className="col-sm-12">
                    <table className="table table-bordered" width="100%">
                      <thead>
                        <tr>
                          <th rowSpan="2">Loại phân bón</th>
                          <th colSpan="2">Lượng phân bón(kg)</th>
                        </tr>
                        <tr>
                          <th>Cho 1ha</th>
                          <th>
                            Cho toàn bộ thửa đất (
                            <NumberFormat
                              value={hienTrang?.dt_ha}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>{" "}
                            ha)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>N</td>
                          <td className="col-so">
                            <NumberFormat
                              value={phanBon.n}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                          <td className="col-so">
                            <NumberFormat
                              value={hienTrang?.dt_ha * phanBon.n}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                        </tr>
                        <tr>
                          <td>P2O5</td>
                          <td className="col-so">
                            <NumberFormat
                              value={phanBon.p}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                          <td className="col-so">
                            <NumberFormat
                              value={hienTrang?.dt_ha * phanBon.p}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                        </tr>
                        <tr>
                          <td>K20</td>
                          <td className="col-so">
                            <NumberFormat
                              value={phanBon.k}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                          <td className="col-so">
                            <NumberFormat
                              value={hienTrang?.dt_ha * phanBon.k}
                              displayType={"text"}
                              thousandSeparator={true}
                              decimalScale={2}
                            ></NumberFormat>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-12">
                    *Mức khuyến cáo mang tính chất tham khảo trên thực tế việc
                    sử dụng phân bón còn phụ thuộc nhiều yếu tố như kỹ thuật
                    canh tác, thời tiết, giống…
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-sm-12">
                    Chúng tôi không chịu bất cứ trách nhiệm nào khi sử dụng
                    khuyến cáo phân bón nếu có bị sụt giảm năng suất, bà con cần
                    tuân thủ theo sự hướng dẫn của cán bộ khuyến nông với tình
                    hình mùa vụ, giống cây trồng thực tế.
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={handleClose}
              >
                <i className="fas fa-sign-out-alt"></i> Đóng
              </button>
            </div>
          </div>
        </div>
        <Loading loading={loading}></Loading>
      </div>
    </Draggable>
  );
};
